// Cor de destaque customizável por lan house (via variável CSS --accent).
const KEY = 'arena_accent';
export const DEFAULT_ACCENT = '#a3e635';

export function applyAccent(color) {
  const c = color || DEFAULT_ACCENT;
  document.documentElement.style.setProperty('--accent', c);
  try { localStorage.setItem(KEY, c); } catch (_) {}
}

// Aplica no boot a última cor conhecida (evita "piscar" o padrão antes de carregar do servidor).
export function loadAccentFromCache() {
  try {
    const c = localStorage.getItem(KEY);
    if (c) document.documentElement.style.setProperty('--accent', c);
  } catch (_) {}
}
